module.exports = __webpack_public_path__ + "img/icon-swap.ab3d366f.svg";